<h2>{{ title }}</h2>
<div class="-content-list">
    <ng-content></ng-content>
</div>